import { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

const SHOW_AFTER_PX = 480

export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          key="scroll-to-top"
          type="button"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          initial={{ opacity: 0, y: 16, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.85 }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.94 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          className="group fixed bottom-5 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-[#1C1917] shadow-[0_8px_24px_rgba(0,0,0,0.18)] transition-colors duration-300 hover:bg-black sm:bottom-8 sm:right-8 sm:h-[52px] sm:w-[52px]"
        >
          {/* Coral glow ring on hover */}
          <span
            className="pointer-events-none absolute inset-0 rounded-full opacity-0 blur-md transition-opacity duration-300 group-hover:opacity-60"
            style={{
              background: 'radial-gradient(circle, rgba(212,87,91,0.55) 0%, transparent 70%)',
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            className="relative transition-transform duration-300 group-hover:-translate-y-0.5 sm:h-5 sm:w-5"
          >
            <path
              d="M12 19V5M12 5L5 12M12 5L19 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </motion.button>
      )}
    </AnimatePresence>
  )
}
